// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3WHO7","footer":"ModalFilter_footer__1a2UR"};